import { SVGProps } from "react";

export function GmailGreen({
    width = 20,
    height = 20,
    viewBox = "0 0 20 20",
    color = "#667085",
    strokeWidth = 1,
    xmlns = "http://www.w3.org/2000/svg",
    ...props
}: SVGProps<SVGSVGElement>) {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18 7.5H22V14V20.5H2V14V7.5H6" stroke="#008934" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M12 9.5V2.5" stroke="#008934" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M15 6.5L12 9.5L9 6.5" stroke="#008934" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M2 7.5L12 15L22 7.5" stroke="#008934" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>

    );
}
